import { render, staticRenderFns } from "./activity-calendar-event-email-view.vue?vue&type=template&id=310dd065&scoped=true"
import script from "./activity-calendar-event-email-view.vue?vue&type=script&lang=ts"
export * from "./activity-calendar-event-email-view.vue?vue&type=script&lang=ts"
import style0 from "./activity-calendar-event-email-view.vue?vue&type=style&index=0&id=310dd065&prod&scoped=true&lang=css"
import style1 from "./activity-calendar-event-email-view.vue?vue&type=style&index=1&id=310dd065&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310dd065",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VCombobox,VContainer,VForm,VIcon,VRadio,VRadioGroup,VRow})
